  function hideTierPoints() {
    document.querySelectorAll('.product-card').forEach(card => {
      const titleLink = card.querySelector('a.product-card__title');
      if (titleLink && titleLink.textContent.toLowerCase().includes('tier point')) {
        card.style.display = 'none';
        console.log('Hidden product card:', titleLink.textContent.trim());
      }
    });
  }

  function removeTierPointText() {
    document.querySelectorAll('a.product-card__title').forEach(titleLink => {
      if (titleLink.textContent.toLowerCase().includes('tier point')) {
        titleLink.textContent = titleLink.textContent.replace(/-?\s*tier point/gi, '').trim();
        console.log('Removed "Tier Point" from title:', titleLink.textContent);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const path = window.location.pathname.toLowerCase();

    if (path === '/pages/unlimited-capsules') {
      // Remove "Tier Point" text from titles but do not hide cards
      removeTierPointText();

      // Observe dynamically added product titles and remove text as well
      const container = document.querySelector('body');
      if (container) {
        const observer = new MutationObserver(mutations => {
          mutations.forEach(() => {
            removeTierPointText();
          });
        });
        observer.observe(container, { childList: true, subtree: true });
      }
    } else {
      // Hide product cards with "Tier Point"
      hideTierPoints();

      // Observe dynamically added product cards and hide as needed
      const container = document.querySelector('body');
      if (container) {
        const observer = new MutationObserver(mutations => {
          mutations.forEach(() => {
            hideTierPoints();
          });
        });
        observer.observe(container, { childList: true, subtree: true });
      }
    }
  });